import {PaletteOptions} from '@mui/material/styles';
import {pink} from './colors';
import {ColorPartial} from '@mui/material/styles/createPalette';

export const basePalette: PaletteOptions = {
  primary: pink,
  secondary: {main: '#9021cc', dark: '#431068'},
  success: {main: '#76ee90'},
  error: {main: '#eb5050'},
  warning: {main: '#ff9b4e'},
};

export const lightPalette: PaletteOptions = {
  ...basePalette,
  mode: 'light',
  error: {
    main: '#EB5050',
    light: '#F23434',
  },
  success: {
    main: '#00AE6C',
  },
  text: {
    primary: 'rgba(11,11,11,0.9)',
    secondary: 'rgba(22,22,23,0.9)',
    disabled: 'rgba(33,33,35,0.9)',
  },
  background: {
    default: '#ffffff',
    paper: '#ffffff',
  },
  grey: {
    '100': '#D0D5DD',
    '200': '#667085',
    '300': '#EFEFEF',
    '400': '#344054',
    '500': '#A7A7A7',
    '600': '#475467',
    '900': '#0B0B0B',
  },
  lightGrey: {
    '100': '#F7F7F7',
    '200': '#D0D5DD',
    '300': '#F7F7F7',
  },
};

export const darkPalette: PaletteOptions = {
  ...basePalette,
  mode: 'dark',
  error: {
    main: '#EB5050',
  },
  success: {
    main: '#19C785',
  },
  text: {
    primary: '#fff',
    secondary: '#fff',
    disabled: '#fff',
  },
  background: {
    default: '#161617',
    paper: '#161617',
  },
  grey: {
    '100': '#344054',
    '200': '#667085',
    '300': '#212123',
    '400': '#344054',
    '500': '#A7A7A7',
    '600': '#475467',
    '900': '#fff',
  },
  lightGrey: {
    '100': '#363535',
    '200': '#D0D5DD',
    '300': '#212123',
  },
};

declare module '@mui/material/styles' {
  interface PaletteOptions {
    lightGrey?: ColorPartial;
  }
}
